/// <amd-module name="TFS/Token/PatTokenPage/Components/PatPage" />
import { NewTokenList } from 'Components/NewTokenList';
import { PageLoadHandler } from "Components/PageLoadHandler";
import { TokenPanelContainer } from 'Components/Panels/TokenPanelContainer';
import { PatPageHeader } from 'Components/PatPageHeader';
import { GlobalProvider } from 'Context/GlobalProvider';
import { mergeStyleSets } from "OfficeFabric/Styling";
import * as React from 'react';
import { memoize } from "VSS/Core/Util/Memoize";
import { VssComponent } from "VSS/Platform/Layout";
import { Page } from 'VSSUI/Page';

export class PatPageComponent extends VssComponent<{}, {}> {

    @memoize
    private static getStyles() {
        return mergeStyleSets({
            container: {
                width: "100%"
            }
        })
    }

    public render() {
        const styles = PatPageComponent.getStyles();

        return (
            <Page className={styles.container}>
                <GlobalProvider pageContext={this.context.pageContext}>
                        <div role="main">
                            <PatPageHeader />
                            <NewTokenList />
                            <TokenPanelContainer />
                            <PageLoadHandler />
                        </div>
                </GlobalProvider>
            </Page>
        )
    }
}

VssComponent.register("vss-token-web.patpage", PatPageComponent);
